import { environment } from "../environments/environment";

export const oktaConfig = {
  issuer: environment.oktaConfig.issuer,
  clientId: environment.oktaConfig.clientId,
  redirectUri: window.location.origin + '/login/callback',
  scopes: ['openid', 'email', 'profile'],
  pkce: true
};